export const DEFAULT_TITLE = 'Заявка отправлена!';
export const DEFAULT_HELPER_TEXT =
  'Теперь ваша заявка доступна риелторам, которые сотрудничают с Циан. В ближайшее время они с вами свяжутся.';
